import axios, { AxiosPromise } from 'axios';
import QueryString from 'qs';
import {
  IAdmissionConsentSearchParams,
  IGetAdmissionConsentList,
  IGetAdmissionConsentSummary,
  IGetSignupConsentList,
  IGetSignupConsentSummary,
  ISignupConsentSearchParams,
} from '../models/consent.model';

const uri = '/mgmt/statistics';

export const getSignupConsentSummary = (
  params: ISignupConsentSearchParams,
): AxiosPromise<IGetSignupConsentSummary> => {
  // isHq 는 mock 전용 편의 필드 — 백엔드는 세션(hqYn)으로 직접 판단하므로 쿼리스트링에서 제외한다.
  const { isHq, ...apiParams } = params;
  const qsParams = QueryString.stringify(apiParams, { arrayFormat: 'repeat' });
  return axios.get(`${uri}/consent/signup/summary?${qsParams}`);
};

export const getSignupConsentList = (
  params: ISignupConsentSearchParams,
): AxiosPromise<IGetSignupConsentList> => {
  const { isHq, ...apiParams } = params;
  const qsParams = QueryString.stringify(apiParams, { arrayFormat: 'repeat' });
  return axios.get(`${uri}/consent/signup/list?${qsParams}`);
};

export const getAdmissionConsentSummary = (
  params: IAdmissionConsentSearchParams,
): AxiosPromise<IGetAdmissionConsentSummary> => {
  const qsParams = QueryString.stringify(params, { arrayFormat: 'repeat' });
  return axios.get(`${uri}/consent/admission/summary?${qsParams}`);
};

export const getAdmissionConsentList = (
  params: IAdmissionConsentSearchParams,
): AxiosPromise<IGetAdmissionConsentList> => {
  const qsParams = QueryString.stringify(params, { arrayFormat: 'repeat' });
  return axios.get(`${uri}/consent/admission/list?${qsParams}`);
};
